


import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { message, Spin } from "antd"; // Import du composant Ant Design pour les messages
import courseService from "../../services/course.service";
// import { useParams } from "react-router-dom";

// const INITIAL_VALUE = {
//     title: "",
//     lessons: "",
//     latest_price: 0.0,
//     before_price: 0.0,
//     duration: "",
//     access_time: "",
//     image: "",
//     category: "",
//     short_desc: "",
//     overview: "",
//     requirements: "",
//     what_you_will_learn: "",
//     who_is_this_course_for: "",
// };
const INITIAL_VALUE = {
    title: "",
    lessons: "",
    latest_price: 0.0,
    before_price: 0.0,
    duration: "",
    access_time: "",
    image: "",
    category: "",
    short_desc: "",
    overview: "",
    requirements: "",
    what_you_will_learn: "",
    who_is_this_course_for: "",
    entrainements_des_connaissances: 0,
    evaluation_des_connaissances: 0,
    controle_des_connaissances: 0,
};



// const CourseCreateForm = ({ btnText }) => {
//     const { courseId } = useParams();
//     const [course, setCourse] = useState(INITIAL_VALUE);
//     const [imagePreview, setImagePreview] = useState("");
//     const navigate = useNavigate();
//     const [isSubmitting, setIsSubmitting] = useState(false); // État pour la barre de progression
//     const [categories, setCategories] = useState([]);
//     const [subcategories, setSubcategories] = useState([]);
//     const [selectedCategory, setSelectedCategory] = useState([]);


//     useEffect(() => {
//         if (courseId) {
//             console.log("Chargement des données pour le cours :", courseId);
//             setCourse({
//                 ...INITIAL_VALUE,
//                 title: "Titre existant",
//                 lessons: 10,
//                 latest_price: 29.99,
//                 before_price: 49.99,
//                 duration: "4 semaines",
//                 access_time: "À vie",
//                 category: "Développement Web",
//                 short_desc: "Ceci est une description courte.",
//                 overview: "<p>Aperçu du cours</p>",
//                 requirements: "<ul><li>Ordinateur</li><li>Connexion Internet</li></ul>",
//                 what_you_will_learn: "<p>Ce que vous apprendrez...</p>",
//                 who_is_this_course_for: "<p>Pour qui est ce cours...</p>",
//             });
//         }
//     }, [courseId]);

const CourseCreateForm = ({ btnText, initialData }) => {
    const [course, setCourse] = useState(INITIAL_VALUE);
    const [imagePreview, setImagePreview] = useState("");
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);

    useEffect(() => {
        if (initialData) {
            setCourse(initialData); // Charge les données initiales dans l'état
            setImagePreview(initialData.imageUrl || ""); // Affiche l'image si disponible
            setSelectedCategory(initialData.category?.id || "");
        }
    }, [initialData]);



    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await courseService.getCategories();
                if (Array.isArray(response)) {
                    setCategories(response);
                } else {
                    console.error("Les données retournées ne sont pas un tableau :", response);
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des catégories :", error);
            }
        };


        fetchCategories();
    }, []);

    const handleCategoryChange = async (e) => {
        const categoryId = e.target.value;
        setSelectedCategory(categoryId);
        setCourse((prev) => ({ ...prev, category: categoryId })); // Met à jour la catégorie sélectionnée

        try {
            const response = await courseService.getSubcategories(categoryId); // Service pour récupérer les sous-catégories
            setSubcategories(response);
        } catch (error) {
            console.error("Erreur lors de la récupération des sous-catégories :", error);
        }
    };


    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "image" && files.length > 0) {
            setCourse((prev) => ({ ...prev, image: files[0] }));
            setImagePreview(URL.createObjectURL(files[0]));
        } else {
            setCourse((prev) => ({ ...prev, [name]: value }));
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!course.title || !selectedCategory) {
            message.error("Veuillez fournir un titre et une catégorie.");
            return;
        }

        try {
            setIsSubmitting(true);

            let uploadedImage = course.image; // Conserver l'image actuelle si aucun nouveau fichier n'est fourni
            if (course.image instanceof File) {
                uploadedImage = await courseService.uploadImage(course.image);
            }

            const courseData = {
                entrainements_des_connaissances: course.entrainementsDesConnaissances,
                evaluation_des_connaissances: course.evaluationDesConnaissances,
                controle_des_connaissances: course.controleDesConnaissances,
                // autres champs
                ...course,
                image: uploadedImage,
                category: { id: selectedCategory },
                // subcategory: course.subcategory ? { id: course.subcategory } : null,
                subcategory: course.subcategory && course.subcategory.id ? { id: course.subcategory.id } : null, // ✅ Correction ici
            };

            if (initialData) {
                // Mise à jour du cours
                await courseService.updateCourse(initialData.id, courseData, course.image);
                message.success("Cours mis à jour avec succès !");
            } else {
                // Création d'un nouveau cours
                await courseService.createCourse(courseData, course.image);
                message.success("Cours créé avec succès !");
            }

            navigate("/mod/courses");
        } catch (error) {
            console.error("Erreur lors de la soumission du formulaire :", error.message);
            message.error(error.message || "Erreur lors de l'opération !");
        } finally {
            setIsSubmitting(false);
        }
    };


    return (

        <form onSubmit={handleSubmit}>
            {/* {isSubmitting && (
                <div className="progress mb-3">
                    <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style={{ width: "100%" }}
                        aria-valuenow="100"
                        aria-valuemin="0"
                        aria-valuemax="100"
                    >
                        Envoi en cours...
                    </div>
                </div>
            )} */}
            {isSubmitting && (
                <div
                    style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(255, 255, 255, 0.9)",
                        padding: "20px",
                        borderRadius: "10px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                    }}
                >
                    <div>
                        <Spin size="large" />
                        <p style={{ marginTop: "10px", fontSize: "16px" }}>Envoi en cours...</p>
                    </div>
                </div>
            )}



            {/* <h2>{courseId ? "Modifier le cours" : "Créer un cours"}</h2> */}
            <h2>{initialData ? "Modifier le cours" : "Créer un cours"}</h2>

            <div className="row">
                {/* Titre et Image */}
                <div className="col-md-6">
                    <label>Titre du cours</label>
                    <input
                        type="text"
                        name="title"
                        className="form-control"
                        value={course.title}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div className="col-md-6">
                    <label>Image du cours</label>
                    {/* <input
                        type="file"
                        name="image"
                        className="form-control"
                        onChange={handleInputChange}
                        required
                    />
                    {imagePreview && <img src={imagePreview} alt="Preview" style={{ maxHeight: "100px" }} />} */}
                    <input
                        type="file"
                        name="image"
                        className="form-control"
                        onChange={handleInputChange}
                    />
                    {imagePreview && <img src={imagePreview} alt="Preview" style={{ maxHeight: "100px" }} />}

                </div>

            </div>

            <div className="row mt-3">
                {/* Champs alignés sur une ligne */}
                <div className="col-md-3">
                    <label>Leçons</label>
                    <input
                        type="number"
                        name="lessons"
                        className="form-control"
                        value={course.lessons}
                        onChange={handleInputChange}
                    />
                </div>

                <div className="col-md-3">
                    <label>Prix actuel</label>
                    <input
                        type="number"
                        name="latest_price"
                        className="form-control"
                        value={course.latest_price}
                        onChange={handleInputChange}
                    />
                </div>

                <div className="col-md-3">
                    <label>Prix régulier</label>
                    <input
                        type="number"
                        name="before_price"
                        className="form-control"
                        value={course.before_price}
                        onChange={handleInputChange}
                    />
                </div>

                <div className="col-md-3">
                    <label>Durée</label>
                    <input
                        type="text"
                        name="duration"
                        className="form-control"
                        value={course.duration}
                        onChange={handleInputChange}
                    />
                </div>
            </div>


            <div className="row mt-3">
                <div className="col-md-4">
                    <label>Entrainements des connaissances</label>
                    <input
                        type="number"
                        name="entrainements_des_connaissances"
                        className="form-control"
                        value={course.entrainements_des_connaissances || 0}
                        onChange={handleInputChange}
                    />
                </div>

                <div className="col-md-4">
                    <label>Évaluation des connaissances</label>
                    <input
                        type="number"
                        name="evaluation_des_connaissances"
                        className="form-control"
                        value={course.evaluation_des_connaissances || 0}
                        onChange={handleInputChange}
                    />
                </div>

                <div className="col-md-4">
                    <label>Contrôle des connaissances</label>
                    <input
                        type="number"
                        name="controle_des_connaissances"
                        className="form-control"
                        value={course.controle_des_connaissances || 0}
                        onChange={handleInputChange}
                    />
                </div>
            </div>




            <div className="row mt-3 align-items-center">
                <div className="col-md-4">
                    <label htmlFor="access_time">Durée d'accès</label>
                    <select
                        id="access_time"
                        name="access_time"
                        className="form-control"
                        value={course.access_time}
                        onChange={handleInputChange}
                    >
                        <option value="À vie">À vie</option>
                        <option value="3 mois">3 mois</option>
                        <option value="6 mois">6 mois</option>
                        <option value="1 an">1 an</option>
                    </select>
                </div>

                <div className="col-md-4">
                    <label htmlFor="category">Catégorie</label>
                    <select
                        id="category"
                        name="category"
                        className="form-control"
                        value={selectedCategory || ""}
                        onChange={handleCategoryChange}
                    >
                        <option value="">Sélectionnez une catégorie</option>
                        {Array.isArray(categories) &&
                            categories.map((category) => (
                                <option key={category.id} value={category.id}>
                                    {category.libelle}
                                </option>
                            ))}
                    </select>
                </div>

                <div className="col-md-4">
                    <label htmlFor="subcategory">Sous-catégorie</label>
                    <select
                        id="subcategory"
                        name="subcategory"
                        className="form-control"
                        value={course.subcategory?.id || ""}
                        onChange={(e) =>
                            setCourse((prev) => ({
                                ...prev,
                                subcategory: e.target.value ? { id: parseInt(e.target.value, 10) } : null, // ✅ Correction ici
                            }))
                        }
                        disabled={!subcategories.length}
                    >

                        <option value="">Sélectionnez une sous-catégorie</option>
                        {Array.isArray(subcategories) &&
                            subcategories.map((subcategory) => (
                                <option key={subcategory.id} value={subcategory.id}>
                                    {subcategory.libelle}
                                </option>
                            ))}
                    </select>
                </div>
            </div>


            <div className="row mt-3">
                <div className="col-md-12">
                    <label>Description courte</label>
                    <textarea
                        name="short_desc"
                        className="form-control"
                        value={course.short_desc}
                        onChange={handleInputChange}
                    />
                </div>
            </div>

            <div className="row mt-3">
                {/* Éditeurs */}
                <div className="col-md-6">
                    <label>Aperçu</label>
                    <Editor
                        apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                        value={course.overview}
                        init={{
                            height: 300,
                            menubar: true,
                            plugins: ["link", "lists", "table", "paste", "code", "help"],
                            toolbar: "undo redo | bold italic underline | link",
                        }}
                        onEditorChange={(content) =>
                            handleInputChange({ target: { name: "overview", value: content } })
                        }
                    />
                </div>

                <div className="col-md-6">
                    <label>Exigences</label>
                    <Editor
                        apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                        value={course.requirements}
                        init={{
                            height: 300,
                            menubar: true,
                            plugins: ["link", "lists", "table", "paste", "code", "help"],
                            toolbar: "undo redo | bold italic underline | link",
                        }}
                        onEditorChange={(content) =>
                            handleInputChange({ target: { name: "requirements", value: content } })
                        }
                    />
                </div>
            </div>

            <div className="row mt-3">
                <div className="col-md-6">
                    <label>Ce que vous allez apprendre</label>
                    <Editor
                        apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                        value={course.what_you_will_learn}
                        init={{
                            height: 300,
                            menubar: true,
                            plugins: ["link", "lists", "table", "paste", "code", "help"],
                            toolbar: "undo redo | bold italic underline | link",
                        }}
                        onEditorChange={(content) =>
                            handleInputChange({ target: { name: "what_you_will_learn", value: content } })
                        }
                    />
                </div>

                <div className="col-md-6">
                    <label>À qui s'adresse ce cours ?</label>
                    <Editor
                        apiKey="v5a0uyztwrsskf09mpu56qttcqnamjr2l64oxdagfxt9zvle"
                        value={course.who_is_this_course_for}
                        init={{
                            height: 300,
                            menubar: true,
                            plugins: ["link", "lists", "table", "paste", "code", "help"],
                            toolbar: "undo redo | bold italic underline | link",
                        }}
                        onEditorChange={(content) =>
                            handleInputChange({ target: { name: "who_is_this_course_for", value: content } })
                        }
                    />
                </div>
            </div>
            <button
                type="submit"
                className="btn btn-primary mt-3"
                disabled={isSubmitting} // Désactiver pendant l'insertion
            >
                {isSubmitting ? "Envoi en cours..." : btnText || "Créer un cours"}
            </button>

        </form>

    );
};

export default CourseCreateForm;
